import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import AuthGuard from 'components/AuthGuard';

// render - Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const Dashboard = Loadable(lazy(() => import('pages/dashboard')));

// render - profile
const ViewProfile = Loadable(lazy(() => import('pages/profile/ViewProfile')));
const EditProfile = Loadable(lazy(() => import('pages/profile/EditProfile')));

// render - plans
const Plans = Loadable(lazy(() => import('pages/plans')));

// render - team
const Team = Loadable(lazy(() => import('pages/team')));

// render - finance
const Transactions = Loadable(lazy(() => import('pages/transactions')));
const Deposit = Loadable(lazy(() => import('pages/deposit')));
const Withdraw = Loadable(lazy(() => import('pages/withdraw')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <DashboardLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/',
      element: <Dashboard />
    },
    {
      path: 'dashboard',
      children: [
        {
          index: true,
          element: <Dashboard />
        },
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'plans',
      element: <Plans />
    },
    {
      path: 'team',
      element: <Team />
    },
    {
      path: 'finance',
      children: [
        { path: 'transactions', element: <Transactions /> },
        { path: 'deposit', element: <Deposit /> },
        { path: 'withdraw', element: <Withdraw /> }
      ]
    },
    {
      path: 'profile',
      children: [
        { path: 'view', element: <ViewProfile /> },
        { path: 'edit', element: <EditProfile /> }
      ]
    }
  ]
};

export default MainRoutes;
